import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SectionItemDto } from '../../../core/models/cms.model';
import { MediaSrcDirective } from '../../directives/media-src.directive';
import { TranslatePipe } from '../../../core/pipes/t.pipe';
import { PRICE_TIER_QUAD_SLOTS, GridSlotPreset } from '../../../core/constants/grid-layout-presets';
import { mediaProfileForSlotHint, sizesForSlotHint, MEDIA_SIZES_QUARTER } from '../../../core/utils/media-image-profile.util';

/**
 * Four dark price-tier promo cards (Figma 538:20008).
 * Slot fields: badgeText = eyebrow (تسوق الآن), title = line (أقل من), description = price (5000 جنيه).
 */
@Component({
  selector: 'app-price-tier-quad',
  standalone: true,
  imports: [CommonModule, RouterModule, MediaSrcDirective, TranslatePipe],
  templateUrl: './price-tier-quad.component.html',
  styleUrls: ['./price-tier-quad.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PriceTierQuadComponent {
  readonly slots = PRICE_TIER_QUAD_SLOTS;

  @Input({ required: true }) items: SectionItemDto[] = [];

  mediaProfileForSlot(slot: GridSlotPreset) {
    return mediaProfileForSlotHint(slot.hintPx);
  }

  sizesForSlot(slot: GridSlotPreset): string {
    return sizesForSlotHint(slot.hintPx, MEDIA_SIZES_QUARTER);
  }

  cellItem(sortOrder: number): SectionItemDto | undefined {
    return this.items.find((i) => i.sortOrder === sortOrder);
  }

  cellLink(item: SectionItemDto | undefined): string | null {
    const url = item?.linkUrl?.trim();
    return url || null;
  }

  trackBySortOrder(_: number, slot: (typeof PRICE_TIER_QUAD_SLOTS)[number]): number {
    return slot.sortOrder;
  }
}
